/**
 * UI permission-keys for the `TEMPLATE_LIBRARY` route (Forms admin authoring surface).
 * ENT-325 — route name matches the BE CSV catalogue row (acl-svc ui-permissions.csv:36),
 * seeded by migration 20260714100001-seed-form-library-write-permission.
 */
export const TemplateLibraryAclKeys = {
  /** Author globals: create/edit/publish/archive. Gates admin UI + mutations. */
  write: 'form_library:write',
} as const;

export type TemplateLibraryAclKey = (typeof TemplateLibraryAclKeys)[keyof typeof TemplateLibraryAclKeys];
